(() => {
  const page = document.getElementById('msl');
  if (!page) return;
  const excluded = new Set(['view', 'preview_theme_id', 'pb', 'section_id', 'sections']);
  const incoming = new URLSearchParams(window.location.search);
  page.querySelectorAll('a.msl-offer-link').forEach((link) => {
    try {
      const destination = new URL(link.href, window.location.origin);
      incoming.forEach((value, key) => {
        if (excluded.has(key.toLowerCase())) return;
        if (!destination.searchParams.has(key)) destination.searchParams.append(key, value);
      });
      link.href = destination.toString();
    } catch (_) { /* Leave the configured destination intact. */ }
  });

  const counters = [...page.querySelectorAll('[data-countdown]')];
  if (counters.length) {
    const formatter = new Intl.DateTimeFormat('en-US', {
      timeZone: page.dataset.countdownTimezone || 'America/New_York',
      year: 'numeric', month: '2-digit', day: '2-digit',
    });
    const dateKey = (timestamp) => {
      const parts = Object.fromEntries(formatter.formatToParts(new Date(timestamp)).map((part) => [part.type, part.value]));
      return Number(parts.year) * 10000 + Number(parts.month) * 100 + Number(parts.day);
    };
    const nextMidnight = (now) => {
      const today = dateKey(now);
      let low = now;
      let high = now + 27 * 60 * 60 * 1000;
      while (low < high) {
        const middle = Math.floor((low + high) / 2);
        if (dateKey(middle) > today) high = middle;
        else low = middle + 1;
      }
      return low;
    };
    let resetAt = nextMidnight(Date.now());
    const renderCountdown = () => {
      const now = Date.now();
      if (now >= resetAt) resetAt = nextMidnight(now);
      const remaining = Math.max(0, Math.ceil((resetAt - now) / 1000));
      const values = {
        hours: Math.floor(remaining / 3600),
        minutes: Math.floor((remaining % 3600) / 60),
        seconds: remaining % 60,
      };
      counters.forEach((counter) => {
        counter.querySelectorAll('[data-countdown-unit]').forEach((number) => {
          number.textContent = String(values[number.dataset.countdownUnit]).padStart(2, '0');
        });
      });
    };
    renderCountdown();
    window.setInterval(renderCountdown, 1000);
  }
})();
